import VueQuillEditor from 'vue-quill-editor';
import '@styles/writer/index.scss';

import $ from 'jquery';
global.$ = $;
const Rails = require('rails-ujs');
Rails.start();

import Vue from 'vue';
import { configureRoutes } from './writer/routes';
const routes = configureRoutes();

Vue.use(VueQuillEditor);
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

const bus = new Vue();
global.bus = bus;

const csrfProtection = function (xhr) {
  var token = $('meta[name="csrf-token"]').attr('content');
  if (token) xhr.setRequestHeader('X-CSRF-Token', token);
};

$.ajaxPrefilter(function (options, originalOptions, xhr) {
  if (!options.crossDomain) {
    csrfProtection(xhr);
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll('[data-js-action]');
  for (const el of els) {
    const keyString = el.getAttribute('data-js-action');
    const keys = keyString.split(',');
    for (const key of keys) {
      const callback = routes.get(key.trim());
      if (callback) {
        callback();
      }
    }
  }
});
